export default __webpack_public_path__ + "static/media/bookBlue.e814cde9.svg";